import { Routes } from '@angular/router';
import { ListControlesComponent } from './pages/list-controles/list-controles.component';
import { PressionControleComponent } from './pages/pression-controle/pression-controle.component';
import { ListEchantillonsComponent } from './pages/list-echantillons/list-echantillons.component';
import { EditionControleComponent } from './pages/list-controles/modals/edition-controle/edition-controle.component';
import { SuiviControlesComponent } from './pages/suivi-controles/suivi-controles.component';
import { SearchManquementsComponent } from './pages/search-manquements/search-manquements.component';
import { PlanningCommissionsComponent } from '../commissions/pages/planning-commissions/planning-commissions.component';
import { EditCommissionComponent } from '../commissions/pages/edit-commission/edit-commission.component';
import { SyntheseJureComponent } from '../commissions/pages/synthese-jure/synthese-jure.component';
import { EditTourneeComponent } from '../tournees/pages/edit-tournee/edit-tournee.component';
import { PlanningTourneesComponent } from '../tournees/pages/planning-tournees/planning-tournees.component';

export const CONTROLES_ROUTES: Routes = [
    {
        path: '',
        data: {
            role: 'ORGANISME',
            domaines: ['VIN'],
            menu: { icon: 'clipboard-check', libelle: 'menu.controles' }
        },
        children: [
            {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full'
            },
            {
                path: 'tournees/planning',
                title: 'Planning des tournées',
                component: PlanningTourneesComponent,
                data: { menu: { libelle: 'Tournées' } }
            },
            {
                path: 'tournees/:idTournee/edit',
                title: 'Tournée',
                component: EditTourneeComponent
            },
            {
                path: 'commissions/planning',
                title: 'Planning des commissions',
                component: PlanningCommissionsComponent,
                data: { menu: { libelle: 'Commissions' } }
            },
            {
                path: 'commissions/:idCommission/edit',
                title: 'Commission',
                component: EditCommissionComponent
            },
            {
                path: 'list',
                title: 'Pressions',
                component: ListControlesComponent,
                data: { menu: { libelle: 'Pressions' } }
            },
            {
                path: 'echantillons',
                title: 'Échantillons',
                component: ListEchantillonsComponent,
                data: { menu: { libelle: 'Échantillons' } }
            },
            {
                path: 'suivi-controles',
                title: 'Suivi des contrôles',
                component: SuiviControlesComponent,
                data: { menu: { libelle: 'Suivi des contrôles' } }
            },
            {
                path: 'search-manquements',
                title: 'Manquements',
                component: SearchManquementsComponent,
                data: { menu: { libelle: 'Manquements' } }
            },
            {
                path: 'new',
                redirectTo: 'new/edit',
                pathMatch: 'full'
            },
            {
                path: ':idControle/edit',
                component: EditionControleComponent
            },
            {
                path: 'pression-controle/new',
                component: PressionControleComponent
            },
            {
                path: 'pression-controle/edit/:id',
                component: PressionControleComponent
            },
            {
                path: 'synthese-jure',
                title: 'Synthèse des jurés',
                component: SyntheseJureComponent,
                data: { menu: { libelle: 'Synthèses des jurés' } }
            }
        ]
    }
];
